import { RouteObject } from 'react-router-dom';
import { EDIT_PROJECT_ROUTES_CONFIG, convertConfigToRouteObject } from './shared/edit-project-routes.config';

const EditProjectRoutes: RouteObject[] = [
  {
    path: ':projectUuid/*',
    id: 'edit-project-root',
    shouldRevalidate: () => false,
    async lazy() {
      const PreviewTemplate = await import('./edit-project.view');
      return { Component: PreviewTemplate.default };
    },
    children: [
      {
        path: ':language/*',
        id: 'edit-project-root-with-language',
        children: EDIT_PROJECT_ROUTES_CONFIG.map(convertConfigToRouteObject),
      },
    ],
  },
];

export default EditProjectRoutes;
